<script setup>
import { computed } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const props = defineProps({
  // A field of a task type's form schema: { key, label, type, required, options }.
  field: { type: Object, required: true },
});

const value = defineModel({ type: [String, Number, Boolean], default: '' });

// Datetime answers are wall-clock values, exactly as the public form sends them.
const INPUT_TYPES = { number: 'number', date: 'date', datetime: 'datetime-local', email: 'email', phone: 'tel' };

const inputType = computed(() => INPUT_TYPES[props.field.type] || 'text');
const options = computed(() =>
  (props.field.options || []).map(option => ({ value: option, label: option }))
);
const label = computed(
  () => `${props.field.label || props.field.key}${props.field.required ? ' *' : ''}`
);
</script>

<template>
  <label
    v-if="field.type === 'checkbox'"
    class="flex items-center gap-2 text-sm text-n-slate-12"
    :data-testid="`task-field-${field.key}`"
  >
    <!-- A real boolean: Vue reads an empty string on a Boolean prop as true, so an unanswered
         checkbox would start ticked. -->
    <Checkbox :model-value="!!value" @update:model-value="checked => (value = checked)" />
    {{ label }}
  </label>
  <div v-else class="flex flex-col gap-1" :data-testid="`task-field-${field.key}`">
    <span class="text-sm text-n-slate-12">{{ label }}</span>
    <ComboBox v-if="field.type === 'list'" v-model="value" :options="options" />
    <Input v-else v-model="value" :type="inputType" />
  </div>
</template>
